import { useDark } from '@vueuse/core'

useDark({ storageKey: 'portal-theme' })

export default defineNuxtRouteMiddleware(async (_to) => {

  // No-op for now

})
